export default "__VITE_ASSET__T9adHC6w__"